<template>
    <div class="verfy-email mx-2" v-if="((!valid_email && valid_email !== undefined) || email_sended) && !dismissed ">
        <b-alert 
            show dismissible variant="warning" 
            v-if="!valid_email && valid_email !== undefined"
            @dismissed="dismissed = true"
            class="mt-2">
            You need to verify your email. 
            <a @click.prevent="sendVerificationMail" href="#">Resend verification mail.</a>
        </b-alert>
        <b-alert show dismissible variant="success" class="mt-2" v-if="email_sended">An email was sent. Please check your inbox or spam folder.</b-alert>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user_id: '',
                email_sended: 0,
                dismissed: false
            }
        },
        created() {
            this.$store.dispatch('fetchAccount')
                .then(() => {
                    this.user_id = this.$store.getters.getAccount.id;
                    this.$auth.user(this.$store.getters.getAccount);
                });
        },
        methods: {
            sendVerificationMail() {
                axios.get(`/users/email/resend/${this.user_id}/`)
                    .then(() => {
                        this.email_sended = 1
                    })
            },
            toggleSidebar() {
                if (localStorage.getItem('sidebarCollapsed') === null) {
                    localStorage.setItem('sidebarCollapsed', 'false');
                }
                else {
                    this.sidebarCollapsed = !this.sidebarCollapsed;
                    localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
                }
            }
        },
        computed: {
            valid_email() {
                return this.$store.getters.getAccount.valid_email;
            }
        }
    }
</script>